<template>
  <div class="request-success-view">
    <img :src="iconImage" alt="success" class="image" />
    <div class="text">
      Дякуємо!<br />Ваше замовлення прийнято.<br />Наші оператори зв’яжуться з
      Вами найближчим часом
    </div>
    <router-link :to="{ name: 'shop' }" class="w-100">
      <app-btn class="btn btn-primary"> ОК </app-btn>
    </router-link>
  </div>
</template>

<script>
import AppBtn from "@/components/common/ui/AppBtn.vue";
import iconImage from "@/assets/request/img-order-accepted.png";

export default {
  name: "CheckoutSuccessView",
  components: {
    AppBtn,
  },
  setup() {
    return {
      iconImage,
    };
  },
};
</script>

<style scoped lang="less">
@import "@/styles/_variables.less";
.request-success-view {
  height: 100vh;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;

  .image {
    max-width: 100%;
    width: 145px;
    height: auto;
    margin-bottom: 25px;

    @media @md {
      width: 200px;
    }

    @media @lg {
      width: 250px;
    }
  }

  .text {
    font-style: normal;
    font-weight: 400;
    font-size: 18px;
    line-height: 22px;
    color: #ffffff;
    margin-bottom: 30px;
  }

  .btn {
    width: 100%;

    @media @md {
      width: auto;
      min-width: 250px;
    }
  }
}
</style>
